export const clippath = {
  polygon: 'polygon(0 0,100% 0,100% 70%,94% 100%,0 100% )',
  upperPolygon: 'polygon(15% 0,100% 0,100% 100%,0 100%,0 30%,15% 0%)',
  countDownPolygon: 'polygon(0 0, 100% 0, 100% 69.09%, 66% 100%, 0 100%)',
}

export const clippathleft = {
  polygon: 'polygon(0 0,100% 0,100% 100%,10% 100%, 0 70%)',
}
